import { render, staticRenderFns } from "./MonthPlanTab.vue?vue&type=template&id=037e2dec&"
import script from "./MonthPlanTab.vue?vue&type=script&lang=js&"
export * from "./MonthPlanTab.vue?vue&type=script&lang=js&"
import style0 from "./MonthPlanTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports